import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { includes } from 'ramda';
import { useSelector } from 'react-redux';

import InfoCircleTooltip from 'components/atoms/GefMui/InfoCircleTooltip';
import { idsWithTooltip } from 'features/views/settings/constants';
import { getRelatedTaskTypesByTypeId } from 'features/views/settings/selectors';

export const TypeWithSubtypesTooltip = ({ item, type }) => {
	const textOnly = (
		<Stack>
			<Typography variant="body3">{item?.description}</Typography>
		</Stack>
	);
	const relatedSubtypes = useSelector((state) => getRelatedTaskTypesByTypeId(state, item?.id));

	const generateTextWithTooltip = (item, relatedSubtypes) => {
		const finalText = (
			<>
				{relatedSubtypes.map((subtype) => (
					<div>{subtype?.description}</div>
				))}
			</>
		);

		return (
			<Stack
				direction="row"
				// eslint-disable-next-line
				sx={(theme) => ({
					alignItems: 'center',
					'.MuiSvgIcon-root': { fontSize: theme.gkcl?.svgIcon?.size15 },
					'.MuiButtonBase-root': { py: '0px' },
				})}
			>
				<Typography variant="body3">{item?.description}</Typography>
				<InfoCircleTooltip text={finalText} />
			</Stack>
		);
	};

	return includes(Number(item.id), idsWithTooltip[type]) ? generateTextWithTooltip(item, relatedSubtypes) : textOnly;
};

TypeWithSubtypesTooltip.propTypes = {
	item: PropTypes.object,
	type: PropTypes.oneOf(['leads', 'tasks']),
};

export default TypeWithSubtypesTooltip;
